
<template>
  <template
      v-if="data"
  >
    <input
        v-model="data.image.title"
        @input="updateImage(data)"
        type="text"
        class="form-control"
        placeholder="Popisek"
    />
    <input
        @input="updateImage(data)"
        v-model="data.image.copyright_title"
        type="text"
        class="form-control mt-1"
        placeholder="Copyright"
    />

    <multiselect
        v-model="data.image.tags"
        :options="tags.option"
        :multiple="true"
        :taggable="true"
        label="language"
        track-by="id"
        @search-change="asyncSearchTag"
        @open="asyncSearchTag"
        @tag="addTag"
        @select="onTagChange"
        :custom-label="formatSelectTag"
        placeholder="tag placehoder"
        :close-on-select="true"
        :clear-on-select="true"
        tagPlaceholder="$t('image.component.input.tags.placeholder_tag')"
        class="form-control mb-1 p-0 border-0 mt-2"

    >
      <template v-slot:tag="{ option, remove  }">
          <span class="btn btn-sm btn-outline-secondary me-1 mb-1">
            <span>{{ option.title }}</span>
            <span class="remove-tag bi bi-x ms-1" @click="removeTag(option)"></span>
          </span>
      </template>
    </multiselect>


  </template>
</template>

<script>
import multiselect  from 'vue-multiselect'
import ImageComponent from "@/components/general/Image";
import axios from "axios";


export default {
  name: "SimpleImageEditComponent",
  props: {
    //"modelValue": [String, Number],
    //"detailId": [String, Number],
    "dataInput": [Object],
  },
  components: {
    ImageComponent,
    multiselect,
  },
  emits: [
    //'update:modelValue',

  ],
  created() {

  },
  mounted() {
      this.data = this.dataInput;
  },

  data() {
    return {
      data: null,
      timer: null,
      tags: {
        timer: null,
        option: []
      }
    }
  },
  methods: {
    updateImage(data){

      clearTimeout(this.timer);
        this.timer = setTimeout(() => {

        let formData = new FormData();
        formData.append('image_id', this.data.image.id );
        if(this.data.image.title ) formData.append('image_title', this.data.image.title );
        if(this.data.image.copyright ) formData.append('image_copyright', this.data.image.copyright_title);
        formData.append('image_tags',  JSON.stringify(this.data.image.tags));

        axios.post( this.getBaseRoot() + this.getApiConfig('image.save_info.path'),
            formData,
            {
              headers: this.getRequestHeaderUpload()
            })
            .then((res) => {
              //this.is_change = false;
            })
            .catch((err) => {
              console.error('image save failure', err);
            })
            .finally(() =>{
              //this.image.is_saving = false;
            })

      }, 700);




    },
    onTagChange(tag){

      let popularTags = localStorage.getItem(
          this.getApiConfig('tags.popularTagName')
      );
      if(
          !popularTags
      ) {
        popularTags = []
        //console.log('setInputChange popularTags: EMPTY', popularTags, );
      }else{
        popularTags = JSON.parse(popularTags);
        //console.log('setInputChange popularTags: LOAD', popularTags, );
      }

      if (!popularTags.includes(tag.id)) {
        popularTags.push(tag.id);
        localStorage.setItem(
            this.getApiConfig('tags.popularTagName'),
            JSON.stringify(popularTags)
        )
      }

      this.updateImage(this.data);
    },
    async asyncSearchTag (query) {
      //console.log("dev asyncFind", query)

      if(this.tags.timer) clearInterval(this.tags.timer);
      this.tags.timer = setTimeout(
          () => {
            axios.defaults.baseURL = this.getBaseRoot();
            let apiPath = this.getApiConfig('tags.select_list.path')

            if (query) apiPath += query
            let popularTags = localStorage.getItem(
                this.getApiConfig('tags.popularTagName')
            );
            if(
                popularTags
                && (!query || query == '')
            ) {
              apiPath += '&tags=' + popularTags
            }
            axios({
              url: apiPath,
              method: "get",
              withCredentials: true,
              headers: this.getRequestHeader(),
            }).then((res) => {
              this.tags.option = res.data.response.list.data;
            })
            .catch((err) => {
              this.tags.option = []
              //console.error("DEV tags catch", err);
            })
          },
          500
      )
    },

    formatSelectTag ({ id, title }) {
      return `${title}`
    },

    addTag (newTag) {
      let formData = new FormData;
      formData.append('tag_title', newTag)
      axios.defaults.baseURL = this.getBaseRoot();
      axios({

        url: this.getApiConfig('tags.create_simple.path'),
        data: formData,
        method: "post",
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        if(res.data.status){
          const newTag = {
            'id': res.data.response.data.id,
            'title': res.data.response.data.nazev
          }
          this.data.image.tags.push(newTag);
          //TODO pridat popularni
        }else{
          alert("nepodarilo se pridat novy stitek")
        }
      })

      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      //this.options.push(tag)
      this.tags.option.unshift(tag)
    },
    removeTag(tag){
      this.updateImage(this.data)
    }
  },
  computed: {

  },

  watch: {

  }
};
</script>
<style lang="scss">

</style>